/* eslint-disable no-multiple-empty-lines */
import { v4 as uuid } from 'uuid'

// https://segment.com/docs/connections/spec/page/

function seg_canContinue() {
  return false // segment is temporarliy disabled
  // return true
  // return import.meta.env.VITE_ENV === 'production' && window.analytics
}

function seg_setCheckoutId(item) {
  window.seg_checkout_id = uuid()
  // console.log('seg_setCheckoutId', window.seg_checkout_id)
}

function seg_getTotalAndCurrency(items) {
  // console.log(items)
  const totalPrice = items.reduce((acc, item) => acc + Number(item?.price?.price || item?.price), 0)
  return {
    total: totalPrice,
    currency: 'USD',
  }
}

function seg_getProduct(item) {
  const plan = item?.plan || item
  const price = item?.price?.price || item?.price
  const res = {
    // product_id: plan?.external_plan_id,
    product_id: plan?.id,
    type: plan?.type,
    tier: plan?.tier,
    billing: plan?.interval,
    price,
    quantity: 1, // if this to be changed total price needs to be changed as well but now we have all by one
    currency: 'USD',
  }
  // console.log(item)
  // console.log('product', res)
  return res
}

function seg_identify({ user_id, email }) {
  if (!seg_canContinue()) return

  if (!window.gw_segment_identified) {
    window.gw_segment_identified = true
    window.analytics.identify(
      user_id, //
      { email },
    )
    if (!window.location.href.includes('https://app.gtowizard.com/')) {
      console.log('seg_identify -- has identified', { user_id, email })
    }
  }
}

function seg_page() {
  if (!seg_canContinue()) return
  if (!window.gw_segment_identified) return

  // console.log('seg_page')
  window.analytics.page()
}

function seg_track(eventKey, params = {}) {
  if (!seg_canContinue()) return

  // console.log('seg_track', eventKey, params)

  const checkoutTrackDict = {
    subscription_dashboard_viewed: 'Subscription Dashboard Viewed',

    // cancel plan
    cancel_subscription_click: 'Cancel Subscription Click',
    cancel_subscription_plans_viewed: 'Cancel Subscriptions Plans Viewed',
    cancel_subscription_step_viewed: 'Cancel Subscription Step Viewed',
    cancel_subscription_step_completed: 'Cancel Subscription Step Completed',

    // update plan
    change_plan_step_viewed: 'Change Plan Step Viewed',
    // subscription_plan_viewed: 'Subscription Plan Viewed',
    checkout_step_viewed: 'Checkout Step Viewed',
    checkout_step_completed: 'Checkout Step Completed',

    // purchase new plan
    subscriptions_offer_viewed: 'Subscriptions Offer Viewed',
    subscription_choosen: 'Subscription Choosen',
    payment_info_entered: 'Payment Info Entered',
    purchase_completed: 'Purchase Completed',
    how_did_you_find_us: 'How Did You Find Us',
    discord_subscriber_role_activated: 'Discord Subscriber Role Activated',
  }

  if (checkoutTrackDict[eventKey]) {
    params.checkout_type = 'Purchase Funnel'
  }

  const uxTrackDict = {
    cussol_dashboard_init: 'cussol_dashboard_init',
    cussol_dashboard_old: 'cussol_dashboard_old',
    cussol_dashboard_new: 'cussol_dashboard_new',
  }

  const dict = {
    ...checkoutTrackDict,
    ...uxTrackDict,
  }

  const name = dict[eventKey]
  if (!name) {
    console.warn('NO KNOWN SEG-KEY ', eventKey)
    debugger
  }

  if (!window.location.href.includes('https://app.gtowizard.com/')) {
    console.log('seg_track-- ', name, params)
  }

  if (!seg_canContinue()) return
  if (!window.gw_segment_identified) {
    console.log('seg_track -- not identified yet')
    return
  }
  window.analytics.track(name, params)
}

export {
  seg_identify, //
  seg_page,
  seg_track,
  seg_getProduct,
  seg_setCheckoutId,
  seg_getTotalAndCurrency,
}
